export const DELETE_PRODUCER				 = 'DELETE_PRODUCER'
export const DELETE_PRODUCER_SUCCESS = 'DELETE_PRODUCER_SUCCESS'
export const DELETE_PRODUCER_FAIL		 = 'DELETE_PRODUCER_FAIL'